/* ============================================================
   MOVASANA — CROSS-SELL

   Der Haken haengt versteckte items[]-Felder an das EINE Kaufformular der Seite.
   Shopify nimmt dann beim Absenden das Hauptprodukt UND die angehakten Produkte
   entgegen — gepruefte Mechanik: sie funktioniert sowohl ueber den normalen
   Kaufknopf als auch ueber unsere Kaufleiste, weil beide dasselbe Formular
   absenden.
   ============================================================ */

class MovasanaAddon extends HTMLElement {
  connectedCallback() {
    /* ACHTUNG, subtile Falle: Weiter unten haengt sich dieses Element selbst an eine
       andere Stelle im Dokument um. Ein Umhaengen ist fuer den Browser ein Entfernen
       und ein erneutes Einfuegen — connectedCallback laeuft also SOFORT WIEDER, haengt
       erneut um, und so fort, bis der Aufrufstapel platzt ("Maximum call stack size
       exceeded", gemessen). Ausserdem wuerden bei jedem Durchlauf neue versteckte
       Felder ans Formular gehaengt.

       Diese Sperre laeuft genau einmal pro Element und beendet beides. */
    if (this.eingerichtet) return;
    this.eingerichtet = true;

    this.formular = document.querySelector('product-form form[data-type="add-to-cart-form"]');
    if (!this.formular) {
      this.remove();
      return;
    }

    this.boxen = Array.from(this.querySelectorAll('.mv-addon__box'));
    if (!this.boxen.length) {
      this.remove();
      return;
    }

    this.anDenKaufknopfSetzen();
    this.felderAnlegen();

    this.boxen.forEach((box) => {
      box.addEventListener('change', () => this.nummerieren());
    });
  }

  /* Der Block gehoert VOR die Kaufknoepfe, nicht dahinter.

     Dahinter waere die naheliegende Stelle — aber im <product-form> stecken nicht nur
     "In den Warenkorb", sondern auch der Express-Knopf (PayPal) und die Bezahl-Icons.
     Gemessen: Der Kaufknopf sitzt bei y=828, der Block landete bei y=1069. Wer bis
     dahin liest, hat sich laengst entschieden.

     Davor gesetzt ist er Teil des Angebots: erst "das noch dazu, 15 % guenstiger",
     dann der Knopf.

     Findet sich das Formular nicht, bleibt der Block stehen, wo er ist — sichtbar und
     benutzbar, nur an schlechterer Stelle. Lieber das als gar kein Cross-Sell. */
  anDenKaufknopfSetzen() {
    const kaufblock = this.formular.closest('product-form');
    if (kaufblock && kaufblock.parentNode) {
      kaufblock.parentNode.insertBefore(this, kaufblock);
    }
  }

  /* Ein Feldpaar pro Produkt, EINMAL angelegt und dann nur noch an- und
     abgeschaltet. Die alte Fremd-Section erzeugte die Felder bei jedem Klick neu
     und entfernte sie wieder — ein Muster, das bei schnellem Hin- und Herklicken
     Karteileichen im Formular hinterlaesst. */
  felderAnlegen() {
    this.felder = this.boxen.map((box) => {
      const id = document.createElement('input');
      id.type = 'hidden';
      id.value = box.dataset.variante;
      id.disabled = true;

      const menge = document.createElement('input');
      menge.type = 'hidden';
      menge.value = '1';
      menge.disabled = true;

      this.formular.appendChild(id);
      this.formular.appendChild(menge);
      return { box, id, menge };
    });
  }

  /* ACHTUNG: Die Nummerierung MUSS bei 0 beginnen und darf keine Luecken haben.
     Schickte man nur items[1] ohne items[0] — etwa weil der Kunde nur das zweite
     von zwei Produkten anhakt —, versteht Shopify die Liste nicht mehr zuverlaessig.
     Deshalb werden die angehakten Produkte bei jeder Aenderung neu durchnummeriert.

     Abgeschaltete Felder (disabled) sendet der Browser gar nicht erst mit — das
     erspart es, sie aus dem Formular zu entfernen und wieder einzuhaengen. */
  nummerieren() {
    let i = 0;
    this.felder.forEach((f) => {
      if (f.box.checked) {
        f.id.name = 'items[' + i + '][id]';
        f.menge.name = 'items[' + i + '][quantity]';
        f.id.disabled = false;
        f.menge.disabled = false;
        i += 1;
      } else {
        f.id.disabled = true;
        f.menge.disabled = true;
      }
    });
  }
}

if (!customElements.get('movasana-addon')) {
  customElements.define('movasana-addon', MovasanaAddon);
}
